import { render, staticRenderFns } from "./DeviceOverviewButtonCard.vue?vue&type=template&id=39891121"
import script from "./DeviceOverviewButtonCard.vue?vue&type=script&lang=ts"
export * from "./DeviceOverviewButtonCard.vue?vue&type=script&lang=ts"
import style0 from "./DeviceOverviewButtonCard.vue?vue&type=style&index=0&id=39891121&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports